module.exports = __webpack_public_path__ + "img/logo1.34a2d714.png";